import HomeworkBetaToggle from 'common/components/BetaToggle/Homework'
import HelpPopup from 'common/components/HelpPopup'
import {isHomeworkBetaEnabled} from 'common/helpers'

const ToolbarIlmversity = () => {
  return (
    <div className='d-flex align-items-center gap-2 gap-lg-3'>
      <HelpPopup />
      {isHomeworkBetaEnabled() && <HomeworkBetaToggle />}
    </div>
  )
}

export {ToolbarIlmversity}
